import moment from "moment";
import { List } from "immutable";
import { 
    CompanyProfileRecord,
    AssociateRecord,
    BankAccountRecord,
    AddressRecord,
    CompanySellerSchemeRecord,
    InterestDetailRecord,
    MarginSubventionRecord,
    CashbackSplitRecord,
    WithholdPercMasterRecord,
    TenorDetailRecord
} from "../records/index";

export const pipelineCreator = () => {
    let pipes = [];
    const pipe = (func, params = []) => {
        pipes.push([func, params]);
        return {
            pipe,
            run
        };
    };
    const run = data =>
        pipes.reduce((val, [func, params]) => func(val, ...params), data);

    return {
        pipe,
        run
    };
};

export const CompanyProfileRecordPipeline = pipelineCreator()
    .pipe(_ =>  {
        if(_.date_of_incorporation) {
            _.date_of_incorporation = moment(_.date_of_incorporation);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.business_start_date) {
            _.business_start_date = moment(_.business_start_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.annual_turnover1_date) {
            _.annual_turnover1_date = moment(_.annual_turnover1_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.annual_turnover2_date) {
            _.annual_turnover2_date = moment(_.annual_turnover2_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.business_start_date) {
            _.business_start_date = moment(_.business_start_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.credit_rating_expiry_date) {
            _.credit_rating_expiry_date = moment(_.credit_rating_expiry_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.create_date) {
            _.create_date = moment(_.create_date);
        }
        return _;
    })
    .pipe(_ =>  {
        if(_.modified_date) {
            _.modified_date = moment(_.modified_date);
        }
        return _;
    })
    .pipe(_ => {
        if(_.bank_accounts && (_.bank_accounts.size || _.bank_accounts.length)) {
            _.bank_accounts = new List(
                _.bank_accounts.map(__ => BankAccountRecordPipeline.run(__))
            ).toMap().mapEntries(([, v]) => [v.id, v]);
        }
        return _;
    })
    .pipe(_ => {
        if(_.associates && (_.associates.size || _.associates.length)) {
            _.associates = new List(
                _.associates.map(__ => AssociateRecordPipeline.run(__))
            ).toMap().mapEntries(([, v]) => [v.id, v]);
        }

        return _;
    })
    .pipe(_ => {
        if(_.addresses && (_.addresses.size || _.addresses.length)) {
            _.addresses = new List(
                _.addresses.map(__ => AddressRecordPipeline.run(__))
            ).toMap().mapEntries(([, v]) => [v.id, v]);
        }

        return _;
    })
    .pipe(_ => new CompanyProfileRecord(_));

export const AddressRecordPipeline = pipelineCreator()
    .pipe(_ => new AddressRecord(_))
    .pipe(_ => _.set("residing_since", moment(_.residing_since)));

export const AddressesPipeline = pipelineCreator()
    .pipe(_ => _.map(__ => AddressRecordPipeline.run(__)))
    .pipe(_ => new List(_).toMap().mapEntries(([, v]) => [v.id, v]));

export const BankAccountRecordPipeline = pipelineCreator()
    .pipe(_ => {
        if(_.create_date){
            _.create_date=moment(_.create_date);
        }
        return _;
    })
    .pipe(_ => {
        if(_.modified_date){
            _.modified_date=moment(_.modified_date);
        }
        return _;
    })
    .pipe(_ => {
        if(!_.associate) {
            _.asssociate = "company";
        }
        return _;
    })
    .pipe(_ => new BankAccountRecord(_));


export const AssociateRecordPipeline = pipelineCreator()
    .pipe(_ =>{
        if(_.dob){
            _.dob=moment(_.dob);
        }
        return _;
    })
    .pipe(_ =>{
        if(_.passport_issue_date){
            _.passport_issue_date=moment(_.passport_issue_date);
        }
        return _;
    })
    .pipe(_ =>{
        if(_.passport_expiry_date){
            _.passport_expiry_date=moment(_.passport_expiry_date);
        }
        return _;
    })
    .pipe(_ =>{
        if(_.passport_issue_date){
            _.passport_issue_date=moment(_.passport_issue_date);
        }
        return _;
    })
    .pipe(_ =>{
        if(_.create_date){
            _.create_date=moment(_.create_date);
        }
        return _;
    })
    .pipe(_ =>{
        if(_.modified_date){
            _.modified_date=moment(_.modified_date);
        }
        return _;
    })
    .pipe(_ => {
        if(_.cibil_supported_report) {
            _.cibil_supported_report = new List(_.cibil_supported_report);
        }
        return _;
    })
    .pipe(_ => new AssociateRecord(_));

export const SellerSchemePipeline = pipelineCreator()
    .pipe(_ => new CompanySellerSchemeRecord(_))
    .pipe(_ => 
        _.withMutations(map =>
            map
                .set("withhold_perc_master", new WithholdPercMasterRecord(map.withhold_perc_master))
                .set("tenor_master", new TenorDetailRecord(map.tenor_master))
                .set("rff_disbursal_configuration", new MarginSubventionRecord(map.rff_disbursal_configuration))
                .set("rff_cash_back_split_master", new CashbackSplitRecord(map.rff_cash_back_split_master))
                .set("interest_master", new InterestDetailRecord(map.interest_master))
                .set("date_of_agreement", map.date_of_agreement && moment(map.date_of_agreement))
        )
    );